import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/reason_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'Reason',
    column_type: 'string',
    column_name: 'name',
  },
  is_active_eq: {
    column_type: 'boolean',
    model_name: 'Reason',
    column_name: 'isActive',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'is_active': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('Reason', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Reason', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
